export const siteAdminsProfileKeys = {
  all: ["site-admins-profile"] as const,
  details: () => [...siteAdminsProfileKeys.all, "detail"] as const,
  detail: () => [...siteAdminsProfileKeys.details()] as const,
};
